import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router/index';
import moment from "moment";
import { HTTP } from "@/utils/http";
import Apis from '@/apis/index';

//=============================================================================================================
Vue.use(Vuex);

//=============================================================================================================
const ACCESS_TOKEN_KEY = 'accessToken';

//=============================================================================================================
const DEFAULT_STATE = {
    viewState: {
        menuExpanded: true,
        hasSearch: false
    },
    // USER DATA
    user: null,
    stations: null,
    stationsSearch: '',
    // active station
    currentStationUid: null,
    currentStation: null,
    stationBoxes: null,
    stationBoxesGrouped: null,
    stationClocks: null,
    stationDayTemplates: null,
    //-------------------------------------------
    currentDayTemplate: null,
    currentClock: null,
    currentBox: null,
    currentTrackType: 0,
    // Edition Modes
    editedDayTemplate: null,
    editedClock: null,
    editedBox: null,
    editTracks: null,
    planningMonth: moment().startOf('month'),
    currentPlanningData: null,
    // load states
    results: {
        loginResult: null,
        stationClockListResult: null,
        permissionsListResult: null,
        stationBoxListResult: null,
        stationDayTemplateListResult: null
    },
    upload: {
        isModalOpened: false
    },
    loadingStates: {
        isTryingToAuthenticate: true,
        isLoadingUser: false,
        //===============================================================================================
        isLoadingStations: false,
        isLoadingPermissions: false,
        isLoadingStation: false,
        //===============================================================================================
        isLoadingStationBoxes: false,
        isLoadingBox: false,
        isLoadingEditedBox: false,
        isCreatingBox: false,
        //===============================================================================================
        isLoadingStationClocks: false,
        isLoadingClock: false,
        isLoadingEditedClock: false,
        isCreatingClock: false,
        //===============================================================================================
        isLoadingStationDayTemplates: false,
        isLoadingDayTemplate: false,
        isLoadingEditedDayTemplate: false,
        isCreatingDayTemplate: false,
        //===============================================================================================
        isLoadingStationPlannings: false,
        isLoadingPlanning: false,
    },
    permissions: null,
    isConstraintModified: false
};
const state = Object.assign({}, DEFAULT_STATE)

//=============================================================================================================
import dnd from './modules/dnd';
import uploads from './modules/upload';
import trackStore from './modules/tracks';
import uploadStore from './modules/upload';
import notifications from './modules/notifications';
import advancedSearch from './modules/advanced-search';
import {Boxes} from "@/store/modules/boxes";
import {Toasts} from "@/store/modules/toasts";
import {Templates } from "@/store/modules/templates";
import {safeObj} from "@/utils/safeObj";
import Search from './modules/search';
//=============================================================================================================
export default new Vuex.Store({
    state,
    modules: {
        dnd,
        Search,
        uploads,
        notifications,
        advancedSearch,
        tracks: trackStore,
        upload: uploadStore,
        Boxes,
        Templates,
        Toasts,
    },
    getters: {
        isAuthenticated: state => { return state.user != null; },
        //===============================================================================================
        isLoadingStationBoxes: state => { return state.loadingStates.isLoadingStationBoxes != null; },
        isLoadingStationClocks: state => { return state.loadingStates.isLoadingStationClocks != null; },
        isLoadingStationDayTemplates: state => { return state.loadingStates.isLoadingStationDayTemplates != null; },
        isLoadingStationPlannings: state => { return state.loadingStates.isLoadingStationPlannings != null; },
        //===============================================================================================
        currentRadio: function (state) {
            var station = (state.stations || {}).items && state.stations.items.filter(station => station.uid.localeCompare(state.currentStationUid) == 0);
            if (station && station.length > 0) return station[0];
        }
    },
    mutations: {
        updateStationsSearch (state, search) {
            state.stationsSearch = search
        },
        reset(state){
            Object.assign(state, DEFAULT_STATE)
        },
        onMenuToggle(state) { state.viewState.menuExpanded = !state.viewState.menuExpanded; },
        onSearchToggle(state) { state.viewState.hasSearch = !state.viewState.hasSearch; },
        onFileUploadModalOpen(state) { state.upload.isModalOpened = true; },
        onFileUploadModalClose(state) { state.upload.isModalOpened = false; },
        // Toggle Box Group
        onBoxCategoryExpand(state, categoryKey) {
            var category = state.stationBoxesGrouped[categoryKey];
            if (category) { category.expanded = !category.expanded; }
        },
        //===============================================================================================
        // Authentication
        //===============================================================================================
        onTryAuthenticateBegin(state) {
            state.loadingStates.isTryingToAuthenticate = true;
            state.results.loginResult = null;
        },
        onAuthenticateBegin: state => state.loadingStates.isLoadingUser = true,
        onTryAuthenticateEnd: state => state.loadingStates.isTryingToAuthenticate = false,
        onAuthenticateEnd: state => state.loadingStates.isLoadingUser = false,
        onAuthenticated(state, loginResponse) {
            try {
                console.log('onAuthenticated------------', loginResponse)
                state.loadingStates.isTryingToAuthenticate = false;
                state.loadingStates.isLoadingUser = false;
                state.results.loginResult = loginResponse;
                if (loginResponse.data != null && loginResponse.data.dataItem != null) {
                    localStorage.setItem(ACCESS_TOKEN_KEY, loginResponse.data.dataItem.accessToken)
                    HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + loginResponse.data.dataItem.accessToken;
                    state.user = loginResponse.data.dataItem;
                }
                else {
                    state.user = null;
                }
            } catch (e) {
                console.log("mutation -> authenticate -> error", e);
            }
        },
        logout: state => {
            localStorage.removeItem(ACCESS_TOKEN_KEY);
            localStorage.removeItem('logging_user_email');
            localStorage.removeItem('logging_user_name');
            HTTP.defaults.headers.common['Authorization'] = null;
            Object.assign(state, DEFAULT_STATE);
            // state.user = null;
            // state.stations = null;
            // state.activateStation = null;
          //  router.push("/").catch(err => {});
        },
        //===============================================================================================
        // Load user stations
        //===============================================================================================
        onStationsLoadBegin: state => state.loadingStates.isLoadingStations = true,
        onStationsLoaded(state, loadResponse) {
            try {
                // console.log("mutation -> onStationsLoaded");
                state.loadingStates.isLoadingStations = false;
                state.results.stationsResult = loadResponse;
                if (loadResponse.data != null && loadResponse.data.dataItem != null) {
                    state.stations = loadResponse.data.dataItem;
                }
                else {
                    state.user = null;
                }
                // console.log(state);
            } catch (e) {
                console.log("mutation -> onStationsLoaded -> error", e);
            }
        },
        onPermissionsLoaded(state, loadResponse) {
            try {
                // console.log("mutation -> onStationsLoaded");
                state.loadingStates.isLoadingPermissions = false;
                state.results.permissionsListResult = loadResponse;
                if (loadResponse.data != null && loadResponse.data.dataItem != null) {
                    state.permissions = loadResponse.data.dataItem;
                }
                else {
                    state.permissions = null;
                }
                // console.log(state);
            } catch (e) {
                console.log("mutation -> onPermissionsLoaded -> error", e);
            }
        },
        getPermission(state , code ) {
            if (state.permissions && state.permissions.items.length > 0 ) {
                state.permissions.items.forEach(role => {
                    if (role.code === code){
                        return true;
                    }
                });
            }
            return false;
        },
        onStationsLoadEnd: state => state.loadingStates.isLoadingStations = false,
        onStationActivate(state, stationUid) { state.currentStationUid = stationUid; },
        onStationActivated(state, station) {
            state.currentStation = station;
            state.currentStationUid = station.uid;
        },
        onLibraryStatsLoad(state, stats) {
            if (state.currentStation) {
                Vue.set(state.currentStation, 'tracksCount', stats.tracksCount);
                Vue.set(state.currentStation, 'filesSize', stats.filesSize);
                return;
            }

            state.currentStation = { ...stats };
        },
        //===============================================================================================
        // Load stations clocks
        //===============================================================================================
        onStationClocksLoadBegin: state => state.loadingStates.isLoadingStationClocks = true,
        onStationClocksLoaded(state, loadResponse) {
            //if (state.currentClock && state.currentClock.StationUid != state.currentStationUid)
            //    state.currentClock = null;
            try {
                //console.log("mutation -> onStationClocksLoaded");
                state.loadingStates.isLoadingStationClocks = false;
                state.results.stationClockListResult = loadResponse;
                if (loadResponse != null && loadResponse.data != null && loadResponse.data.dataItem != null) {
                    // console.log("ClockLoaded :", loadResponse.data.dataItem);
                    state.stationClocks = loadResponse.data.dataItem;
                }
                else {
                    state.stationClocks = null;
                }
            } catch (e) {
                //console.log("mutation -> onStationClocksLoaded -> error", e);
            }
        },
        onStationClocksLoadEnd: state => state.loadingStates.isLoadingStationClocks = false,
        //===============================================================================================
        // Load stations Templates
        //===============================================================================================
        onStationDayTemplatesLoadBegin: state => state.loadingStates.isLoadingStationDayTemplates = true,
        onStationDayTemplatesLoaded(state, loadResponse) {
            // state.currentDayTemplate = null;
            try {
                //console.log("mutation -> onStationDayTemplatesLoaded");
                state.loadingStates.isLoadingStationDayTemplates = false;
                state.results.stationDayTemplateListResult = loadResponse;
                if (loadResponse != null && loadResponse.data != null && loadResponse.data.dataItem != null) {
                    state.stationDayTemplates = loadResponse.data.dataItem;
                }
                else {
                    state.stationDayTemplates = null;
                }
            } catch (e) {
                //console.log("mutation -> onStationDayTemplatesLoaded -> error", e);
            }
        },
        onStationDayTemplatesLoadEnd(state) { state.loadingStates.isLoadingStationDayTemplates = false; },
        //===============================================================================================
        // Load stations boxes
        //===============================================================================================
        onStationBoxesLoadBegin(state) { state.loadingStates.isLoadingStationBoxes = true; },
        onStationBoxesLoaded(state, loadResponse) {
            //state.currentBox = null;
            state.stationBoxesGrouped = null;
            try {
                // console.log("mutation -> onStationBoxesLoaded");
                state.loadingStates.isLoadingStationBoxes = false;
                state.results.stationBoxListResult = loadResponse;
                if (loadResponse != null && loadResponse.data != null && loadResponse.data.dataItem != null) {
                    state.stationBoxes = loadResponse.data.dataItem;
                    if (state.stationBoxes != null && state.stationBoxes.items != null) {
                        var groups = {
                            "MUSIC":{ key: "MUSIC", expanded: true, items: [], position:1 },
                            "JINGLE":{ key: "JINGLE", expanded: true, items: [], position:2 },
                            "UNDEFINED":{ key: "UNDEFINED", expanded: true, items: [], position:3 },
                            "PODCAST":{ key: "PODCAST", expanded: true, items: [], position:4 }
                        };
                        state.stationBoxes.items.forEach(boxItem => {
                            var typeKey = (boxItem.trackType || "");
                            if (groups[typeKey] === undefined) {
                                groups[typeKey] = { key: typeKey, expanded: true, items: [], position:groups.length+1 };
                            }
                            groups[typeKey].items.push(boxItem);
                        });
                        const { PROMO, ...rest } = groups;
                        state.stationBoxesGrouped = rest;
                    }
                }
            } catch (e) {
                console.log("mutation -> onStationBoxesLoaded -> error", e);
            }
        },
        onStationBoxesLoadEnd(state) { state.loadingStates.isLoadingStationBoxes = false; },
        //===============================================================================================
        // Create elements
        //===============================================================================================
        onBoxUpdate(state, box)
        {
            var matching = state.stationBoxes.items.filter(menuItem => menuItem.uid == box.uid);
            if (matching.length >0){
                Object.assign(matching[0], box)
            }
        },
        onBoxCreation(state) {
            state.loadingStates.isCreatingBox = true;
            state.loadingStates.isCreatingClock = state.loadingStates.isCreatingDayTemplate = false;
        },
        onClockCreation(state) {
            state.loadingStates.isCreatingClock = true;
            state.loadingStates.isCreatingBox = state.loadingStates.isCreatingDayTemplate = false;
        },
        onDayTemplateCreation(state) {
            state.loadingStates.isCreatingDayTemplate = true;
            state.loadingStates.isCreatingBox = state.loadingStates.isCreatingClock = false;
        },
        //-----------------------------------------------------------------------------------------------
        onBoxCreationEnded(state, newItem) {
            state.loadingStates.isCreatingBox = false;
        },
        onClockCreationEnded(state, newItem) {
            state.loadingStates.isCreatingClock = false;
        },
        onDayTemplateCreationEnded(state, newItem) {
            state.loadingStates.isCreatingDayTemplate = false;
        },
        //-----------------------------------------------------------------------------------------------
        onBoxEdition(state) {
            state.loadingStates.isEditingBox = true;
            state.loadingStates.isEditingDayTemplate = state.loadingStates.isEditingClock = false;
        },
        onClockEdition(state) {
            state.loadingStates.isEditingClock = true;
            state.loadingStates.isEditingDayTemplate = state.loadingStates.isEditingBox = false;
        },
        onDayTemplateEdition(state) {
            state.loadingStates.isEditingDayTemplate = true;
            state.loadingStates.isEditingBox = state.loadingStates.isEditingClock = false;
        },
        //-----------------------------------------------------------------------------------------------
        onBoxEditionEnded(state, newItem) {
            state.loadingStates.isEditingBox = false;
        },
        onClockEditionEnded(state, newItem) {
            state.loadingStates.isEditingClock = false;
        },
        onDayTemplateEditionEnded(state, newItem) {
            state.loadingStates.isEditingDayTemplate = false;
        },
        setCurrentClock(state, data) {
            if(Object.keys(data).length){
                state.currentClock = data
            }
        },
        //===============================================================================================
        // Load Elements
        //===============================================================================================
        onBoxLoadBegin(state) { state.loadingStates.isLoadingBox = true; },
        onBoxLoaded(state, box) { state.currentBox = box; },
        onBoxLoadEnd(state) { state.loadingStates.isLoadingBox = false; },
        //-----------------------------------------------------------------------------------------------
        onClockLoadBegin(state) { state.loadingStates.isLoadingClock = true; },
        onClockLoaded(state, clock) { state.currentClock = clock; },
        onClockLoadEnd(state) { state.loadingStates.isLoadingClock = false; },
        //-----------------------------------------------------------------------------------------------
        onDayTemplateLoadBegin(state) { state.loadingStates.isLoadingDayTemplate = true; },
        onDayTemplateLoaded(state, dt) { state.currentDayTemplate = dt; },
        onDayTemplateLoadEnd(state) { state.loadingStates.isLoadingDayTemplate = false; },
        //-----------------------------------------------------------------------------------------------
        onEditedBoxLoadBegin(state) { state.loadingStates.isLoadingEditedBox = true; },
        onEditedBoxLoaded(state, box) { state.editedBox = box; },
        onEditedBoxLoadEnd(state) { state.loadingStates.isLoadingEditedBox = false; },
        //-----------------------------------------------------------------------------------------------
        onEditedClockLoadBegin(state) { state.loadingStates.isLoadingClock = true; },
        onEditedClockLoaded(state, clock) { state.currentClock = clock; },
        onEditedClockLoadEnd(state) { state.loadingStates.isLoadingClock = false; },
        //-----------------------------------------------------------------------------------------------
        onEditedDayTemplateLoadBegin(state) { state.loadingStates.isLoadingEditedDayTemplate = true; },
        onEditedDayTemplateLoaded(state, dt) { state.editedDayTemplate = dt; },
        onEditedDayTemplateLoadEnd(state) { state.loadingStates.isLoadingEditedDayTemplate = false; },
        //-----------------------------------------------------------------------------------------------
        onPlanningDataLoaded(state, data) { state.currentPlanningData = data; },
        onPlanningChangeDate(state, newData) { state.planningMonth = newData; },
        setEditTracks(state, tracks) { state.editTracks = tracks; },
        setTrackType(state, type) { state.currentTrackType = type; },
        setStatusConstraint(state, payload) {
            state.isConstraintModified = payload
        }
    },
    actions: {
        updateStationsSearch ({ commit }, value) {
            commit('updateStationsSearch', value)
        },
        tryAuthenticate({ commit }) {
            try {
                let that = this;
                commit('onTryAuthenticateBegin');
                var accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
                if (accessToken) {
                    HTTP.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                } else {
                    commit("onTryAuthenticateEnd")
                    commit('logout')

                    return
                }

                HTTP
                    .get('api/account/user-data')
                    .then(
                        (response) => {
                            if (response.data.dataItem != null) {
                                commit('onAuthenticated', response);
                                if (response.data != null && response.data.dataItem != null) {
                                    that.dispatch('loadUserStations');
                                   // that.dispatch('loadUserPermission');
                                }
                            }
                        },
                        (response) => { })
                    .then(() => commit("onTryAuthenticateEnd"));
            } catch (e) {
                console.log("tryAuthenticate -> error:", e);
            }
        },
        authenticate({ commit } , data ) {
            console.log('authenticate', data)
            try {
                let that = this;
                commit('onAuthenticateBegin');
                // Dont need the authorization header on login
                HTTP.defaults.headers.common['Authorization'] = "";
                // HTTP.post(Apis.account.login, context.data)
                //     .then(
                //         function (response) {
                //             if (response.data.dataItem != null) {
                //                 commit('onAuthenticated', response);
                //                 if (response.data != null && response.data.dataItem != null) {
                //console.log("Account Login Data", JSON.stringify(response.data));


                if (data.user) {
                    console.log(data.user)
                       // commit('onAuthenticated', data.user);
                       state.user = data.user;
                       console.log("Account Login Data", JSON.stringify(data.user));
                       localStorage.setItem('logging_user_email', data.user.email);
                       localStorage.setItem('logging_user_name', data.user.name);
                }
                localStorage.setItem(ACCESS_TOKEN_KEY, data.token)

                HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
                that.dispatch('loadUserStations');
                //             }
                //         }
                //     }
                //     ,function (error)  {
                //         console.log("Error",JSON.stringify(error), error.message);
                //         commit('onAuthenticated', (error.response ||{}).statusText || error.message);
                //     }
                // )
                // .then(() => {
                commit("onAuthenticateEnd")
                //         })
                 } catch (e) {
                  console.log('authenticate', e);


        }
        },
        loadUserStations({ commit }) {
            try {
                let that = this;
                // console.log("Try Load stations");
                commit('onStationsLoadBegin');
                HTTP.get('api/station/list', {
                        params:{
                            pageSize:100000
                        }
                    })
                    .then(
                        (response) => {
                            console.log('---------------' , response)
                            if (response && response.data.dataItem != null) {
                                commit('onStationsLoaded', response);
                                that.dispatch('activateStationByUid', state.currentStationUid);
                            }
                        },
                        (response) => { console.log("Error ->", response); })
                    .then((response) => { console.log('---------------' , response);
                        commit("onStationsLoadEnd") });
            } catch (e) {
                console.log("loadUserStations -> error:", e);
            }
        },
        loadUserPermission({ commit }) {
            try {
                let that = this;
                HTTP.get('/api/permission/list')
                    .then(
                        (response) => {
                            if (response.data.dataItem != null) {
                                commit('onPermissionsLoaded', response);
                               // that.dispatch('activateStationByUid', state.currentStationUid);
                            }
                        },
                        (response) => { console.log("Error ->", response); });
                    // .then(() => // commit("onStationsLoadEnd")
                   // );
            } catch (e) {
                console.log("loadUserPermission -> error:", e);
            }
        },
        async createStation({commit, dispatch}, {name, labelCategoryID , styles , targets}) {
            const params = { name, labelCategoryID , styles , targets}

            try {
              const response = await HTTP.post('api/station/create', params)

              dispatch('loadUserStations');

              return response.data.dataItem
            } catch (error) {
              throw error
            }
        },
        editStation({commit, dispatch}, {stationUid, name}) {
            return new Promise((resolve, reject) => {
                const params = { stationUid, name }
                HTTP.post('api/station/rename', params)
                    .then(e => {
                        safeObj(e) && dispatch('loadUserStations');
                        resolve(e.data.dataItem)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        deleteStation({ commit, dispatch }, { stationUid, name }) {
          return new Promise((resolve, reject) => {
            HTTP
              .post('api/station/remove', {
                stationUid
              })
              .then(response => {
                console.log('response', response)
                dispatch('loadUserStations')
                resolve()
              })
              .catch(error => {
                console.log('error', error)
                reject(error)
              })
          })
        },
        //==============================================================================================
        // Load station items
        //==============================================================================================
        activateStationByUid({ commit }, stationUid) {
            commit("onStationActivate", stationUid);
            // console.log("Action : activateStationByUid", "", stationUid, state.currentStationUid);
            if (state.stations != null && state.stations.items != null) {
                var stationRes = state.stations.items.filter(station => station.uid.localeCompare(state.currentStationUid) == 0)
                if (stationRes.length > 0)
                    this.dispatch('activateStation', stationRes[0]);
                else
                    this.dispatch('loadStation', stationUid);
            }
        },
        loadStation({commit}, stationUid){
            try {
                if (stationUid !== null) {
                    HTTP
                        .get('api/station/'+stationUid)
                        .then(
                            (response) => {
                                if (response.data.dataItem !== null) {
                                    this.dispatch('activateStation', response.data.dataItem);
                                }
                            },
                            (response) => { console.log("Error -> load Station ->", response); })
                    ;
                }
                else {
                    commit('onStationClocksLoaded', null);
                }
            } catch (e) {
                console.log("loadStationClocks -> error:", e);
            }
        },
        activateStation({ commit }, station) {
            try {
                commit('onStationActivated', station);
                this.dispatch('loadStationClocks', station.uid);
                this.dispatch('loadStationBoxes', station.uid);
                this.dispatch('loadStationDayTemplates', station.uid);
                this.dispatch('loadStationLibraryStats', station.uid);
                this.commit('advancedSearch/updateFilters', [], true)
                this.dispatch('advancedSearch/reset', null, true)
            }
            catch (e) { }
        },
        loadStationClocks({ commit }, stationUid) {
            // console.log("Load clocks -->", stationUid);
            try {
                // console.log("Try Load station clocks");
                commit('onStationClocksLoadBegin');
                if (stationUid !== null) {
                    HTTP
                        .get('api/clocks/list', {
                            params: {
                                radiouid: stationUid,
                                sortField: 'name',
                                sortAscending: true,
                                pageSize: 0,
                                page: 0,
                                isAdvanced: false
                            }
                        })
                        .then(
                            (response) => { if (response.data.dataItem !== null) { commit('onStationClocksLoaded', response); } },
                            (response) => { console.log("Error -> loadStationClocks s->", response); })
                        .then(() => commit("onStationClocksLoadEnd"));

                }
                else {
                    commit('onStationClocksLoaded', null);
                }
            } catch (e) {
                console.log("loadStationClocks -> error:", e);
            }
        },
        refreshBoxStats({commit}, {stationUid, boxUid, reloadAll }){
            try {
                if (boxUid && !reloadAll){
                    HTTP.get(Apis.boxes.details, {
                        params:{
                        stationUid,
                        boxUid
                    }})
                    .then((response)=>{
                        const { dataItem, errors, isSuccess } = response.data;
                        if (dataItem && dataItem.statistics)
                        {
                            commit('onBoxUpdate',dataItem)
                        }
                    })
                }
                else
                {
                    HTTP.get('api/boxes/list', {
                            params: {
                                radioUid: stationUid,
                                sortField: 'name',
                                sortAscending: true,
                                pageSize: 1000,
                                page: 0,
                                isAdvanced: true
                            }
                    }).then(response => {
                        response.data.dataItem.items.forEach(element => {
                            commit('onBoxUpdate',element)
                        });
                    });

                }

            } catch (error) {
                console.error(error);
            }
        },
        loadStationBoxes({ commit }, stationUid) {
            try {
                commit('onStationBoxesLoadBegin');
                if (stationUid != null) {
                    HTTP
                        .get('api/boxes/list', {
                            params: {
                                radioUid: stationUid,
                                sortField: 'name',
                                sortAscending: true,
                                pageSize: 1000,
                                page: 0,
                                isAdvanced: true
                            }
                        })
                        .then(
                            (response) => { if (response.data.dataItem != null) {
                                commit('onStationBoxesLoaded', response); }
                            },
                            (response) => {
                                console.log("Error -> loadStationBoxes ->", response);
                            })
                        .then(() => commit("onStationBoxesLoadEnd"));
                }
                else {
                    commit('onStationBoxesLoaded', null);
                }
            } catch (e) {
                console.log("loadUserStations -> error:", e);
            }
        },
        loadStationDayTemplates({ commit }, stationUid) {
            try {
                // console.log("Try Load day templates");
                commit('onStationDayTemplatesLoadBegin');
                if (stationUid != null) {
                    HTTP
                        .get('api/daytemplates/list', {
                            params: {
                                radiouid: stationUid,
                                sortField: 'name',
                                sortAscending: true,
                                pageSize: 0,
                                page: 0,
                                isAdvanced: true
                            }
                        })
                        .then(
                            (response) => { if (response.data.dataItem != null) { commit('onStationDayTemplatesLoaded', response); } },
                            (response) => { console.log("Error -> loadStationDayTemplates ->", response); })
                        .then(() => commit("onStationDayTemplatesLoadEnd"));
                }
                else {
                    commit('onStationDayTemplatesLoaded', null);
                }
            } catch (e) {
                console.log("loadStationDayTemplates -> error:", e);
            }
        },
        loadStationLibraryStats({ commit }, stationUid) {
            try {
                HTTP.get('api/library/statistics', {
                    params: { stationUid }
                }).then((response) => {
                    const data = response.data.dataItem;
                    const stats = {
                        filesSize: data.filesSize,
                        tracksCount: data.tracksCount
                    };

                    commit('onLibraryStatsLoad', stats);
                })
            } catch (error) {
                console.log('library stats api error :', error);
            }
        },
        setPlanningData({ commit }, data) {
            commit('onPlanningDataLoaded', data);
        },
        //==============================================================================================
        // Load single items
        //==============================================================================================
        loadClock({ commit }, clockData) {
            // console.log("Load clock --> ", clockData);
            try {
                if (clockData != null && clockData.stationUid) {
                    commit((clockData.isEditing ? 'onEditedClockLoadBegin' : 'onClockLoadBegin'));
                    HTTP
                        .get('api/clocks/details', {
                            params: clockData
                        })
                        .then(
                            (response) => {
                                // console.log("Clock Loaded: ", response.data.dataItem);
                                commit((clockData.isEditing ? 'onEditedClockLoaded' : 'onClockLoaded'), response.data.dataItem);
                            },
                            (response) => {
                                console.log("Error -> loadClock ->", response);
                                commit(clockData.isEditing ? 'onEditedClockLoaded' : 'onClockLoaded', null);
                            })
                        .then(() => commit(clockData.isEditing ? "onEditedClockLoadEnd" : "onClockLoadEnd"));
                }
                else {
                    commit((clockData.isEditing ? 'onEditedClockLoaded' : 'onClockLoaded'), null);
                    commit(clockData.isEditing ? "onEditedClockLoadEnd" : "onClockLoadEnd");
                }
            } catch (e) {
                console.log("loadClock -> error:", e);
            }
        },
        loadDayTemplate({ commit }, daytemplateData) {
            try {
                // console.log("Try Load DayTemplate");
                if (daytemplateData != null && daytemplateData.stationUid) {
                    commit(daytemplateData.isEditing ? 'onEditedDayTemplateLoadBegin' : 'onDayTemplateLoadBegin');
                    HTTP
                        .get('api/daytemplates/details', {
                            params: daytemplateData
                        })
                        .then(
                            (response) => {
                                if (response.data.dataItem != null) {
                                    commit(daytemplateData.isEditing ? 'onEditedDayTemplateLoaded' : 'onDayTemplateLoaded', response.data.dataItem);
                                }
                                else {
                                    commit(daytemplateData.isEditing ? 'onEditedDayTemplateLoaded' : 'onDayTemplateLoaded', null);
                                }
                            },
                            (response) => { console.log("Error -> loadDayTemplate ->", response); })
                        .then(() => commit(daytemplateData.isEditing ? "onEditedDayTemplateLoadEnd" : "onDayTemplateLoadEnd"));

                }
                else {
                    commit(daytemplateData.isEditing ? 'onEditedDayTemplateLoaded' : 'onDayTemplateLoaded', null);
                }
            } catch (e) {
                console.log("loadDayTemplate -> error:", e);
            }
        },
        loadBox({ commit }, boxData) {
            // console.log("Load Box -->", boxData);
            try {
                // console.log("Try Load Box");
                if (boxData != null && boxData.stationUid) {
                    commit(boxData.isEditing ? 'onEditedBoxLoadBegin' : 'onBoxLoadBegin');
                    HTTP
                        .get('api/boxes/details', {
                            params: boxData
                        })
                        .then(
                            (response) => {
                                commit(boxData.isEditing ? 'onEditedBoxLoaded' : 'onBoxLoaded', response.data.dataItem);
                            },
                            (response) => {
                                console.log("Error -> loadBox ->", response);
                                commit(boxData.isEditing ? 'onEditedBoxLoaded' : 'onBoxLoaded', null);
                            })
                        .then(() => commit(boxData.isEditing ? "onEditedBoxLoadEnd" : "onBoxLoadEnd"));
                }
                else {
                    commit(boxData.isEditing ? 'onEditedBoxLoaded' : 'onBoxLoaded', null);
                }
            } catch (e) {
                console.log("loadBox -> error:", e);
            }
        },
        //==============================================================================================
        // Planning actions
        //==============================================================================================
        toggleCategory({ commit }, catData) {
            try {
                commit('onBoxCategoryExpand', catData);
            }
            catch (e) { }
        },
        //==============================================================================================
        // Planning actions
        //==============================================================================================
        planningNextMonth({ commit }) {
            // console.log("Store => planningNextMonth");
            commit("onPlanningChangeDate", moment(state.planningMonth).add(1, "months").startOf("month"));
        },
        planningCurrentMonth({ commit }) {
            // console.log("Store => planningCurrentMonth");
            commit("onPlanningChangeDate", moment().startOf("month").startOf("month"));
        },
        planningPreviousMonth({ commit }) {
            // console.log("Store => planningPreviousMonth");
            commit("onPlanningChangeDate", moment(state.planningMonth).add(-1, "months").startOf("month"));
        },
        //==============================================================================================
        // Box action
        //==============================================================================================
        // Need backend implementation to test
        async updateBoxFilters({ state, commit }, filters) {
            const params = {
                filters,
                boxUid: state.currentBox.uid,
                stationUid: state.currentStationUid,
                pageSize: 1000,
                page: 0,
            };

            return new Promise((resolve, reject) => {
                HTTP.post(Apis.boxes.updateFilters, params)
                    .then(response => resolve(response))
                    .catch(error => {
                        commit('updateResults', []);
                        reject(error)
                    })
            })
        }

        //==============================================================================================
        // Delete items
        //==============================================================================================
        // async onClockRemove({ state, dispatch }, clockUid) {
        //     try {
        //         // const response = await HTTP.post('/api/clocks/remove', {
        //         //     stationUid: state.currentStationUid,
        //         //     clockUid: clockUid
        //         // });

        //         dispatch('loadStationClocks', state.currentStationUid);
        //     }
        //     catch(e) {
        //         console.log('error duplicat clock :', e);
        //     }
        // }
    },
})
